import { slideUp, slideDown, slideToggle } from './libs/slide';

document.addEventListener('DOMContentLoaded', function () {
  const addTourTermButton = document.getElementById('add-tour-term');

  if (addTourTermButton) {
    const tourTermsForm = document.getElementById('tour-terms');

    const maxIndex = parseInt(addTourTermButton.dataset.maxIndex);
    let tourTermIndex = maxIndex;

    addTourTermButton.addEventListener('click', function () {
      const newTourTermForm = document.createElement('div');
      newTourTermForm.classList.add('tour-term');

      const today = new Date();
      const nextYear = new Date(today);
      nextYear.setFullYear(today.getFullYear() + 1);
      nextYear.setDate(nextYear.getDate() - 1);

      newTourTermForm.innerHTML = `
        <div class="input-date">
          <div class="input-date-box">
            <label for="tour_application_tour_terms_attributes_${tourTermIndex}_start_date" class="input-date-box__label">開始</label>
            <input type="date" id="tour_application_tour_terms_attributes_${tourTermIndex}_start_date" name="tour_application[tour_terms_attributes][${tourTermIndex}][start_date]" max="${nextYear.toISOString().split('T')[0]}">
          </div>
          <div class="input-date-box">
            <label for="tour_application_tour_terms_attributes_${tourTermIndex}_end_date" class="input-date-box__label">終了</label>
            <input type="date" id="tour_application_tour_terms_attributes_${tourTermIndex}_end_date" name="tour_application[tour_terms_attributes][${tourTermIndex}][end_date]" max="${nextYear.toISOString().split('T')[0]}">
          </div>
        </div>
      `;

      tourTermsForm.appendChild(newTourTermForm);
      tourTermIndex++;
    });

    const heldValue = document.getElementById('session-held').getAttribute('data-held');
    if (tourTermIndex === 0 || heldValue !== 'period_holding') {
      addTourTermButton.click();
    }
  }

  // 画像削除ボタンが押された場合
  const deleteImageButtons = document.querySelectorAll('[id *= "tour_remove_image_button_"]');
  deleteImageButtons.forEach((buttonElement) => {
    buttonElement.addEventListener('click', (e) => {
      // 画像を一旦非表示にする
      buttonElement
        .closest('div.tour-image-field')
        .querySelector('.preview_tour_image')
        .classList.toggle('d-none', true);
      // 削除フラグに[1]を設定する
      e.target.querySelector('input[type=checkbox]').checked = true;
    }, { once: true })
  });

  // PDF削除ボタンが押された場合
  const deletePdfButtons = document.querySelectorAll('[id *= "tour_remove_pdf_button_"]');
  deletePdfButtons.forEach((buttonElement) => {
    buttonElement.addEventListener('click', (e) => {
      // 画像を一旦非表示にする
      buttonElement
        .closest('div.tour-pdf-field')
        .querySelector('.preview_tour_pdf')
        .classList.toggle('d-none', true);
      // 削除フラグに[1]を設定する
      e.target.querySelector('input[type=checkbox]').checked = true;
    }, { once: true })
  });

  // 戻るボタンで戻ってきた場合にファイル選択に画像ファイルを設定する
  const imageUrlElements = document.querySelectorAll('[id *= "tour_image_url_"]');
  imageUrlElements.forEach((imageUrlElement) => {
    if (imageUrlElement.value) {
      fetch(imageUrlElement.value.split(',')[0]).then(async (res) => {
        const contentType = await res.headers.get('Content-Type');
        const blob = await res.blob();
        const file = new File([blob], imageUrlElement.value.split(',')[1], { contentType });
        const dt = new DataTransfer();
        dt.items.add(file);
        imageUrlElement.closest('div.tour-image-field').querySelector('input[type="file"]').files = dt.files;
      });
    }
  });

  // 戻るボタンで戻ってきた場合にファイル選択にPDFファイルを設定する
  const pdfUrlElements = document.querySelectorAll('[id *= "tour_pdf_url_"]');
  pdfUrlElements.forEach((pdfUrlElement) => {
    if (pdfUrlElement.value) {
      fetch(pdfUrlElement.value.split(',')[0]).then(async (res) => {
        const contentType = await res.headers.get('Content-Type');
        const blob = await res.blob();
        const file = new File([blob], pdfUrlElement.value.split(',')[1], { contentType });
        const dt = new DataTransfer();
        dt.items.add(file);
        pdfUrlElement.closest('div.tour-pdf-field').querySelector('input[type="file"]').files = dt.files;
      });
    }
  });

  // 画像が設定された場合にプレビュー表示を行う
  const imageElements = document.querySelectorAll('[id^="tour_"][id$="_image"]');
  imageElements.forEach((imageElement) => {
    imageElement.addEventListener('change', (e) => {
      const parentElement = e.target.closest('div.tour-image-field');
      const imgDivElement = parentElement.querySelector('div.preview_tour_image');
      const [file] = e.target.files;

      if (file) {
        const img = document.createElement('img');
        img.setAttribute('src', URL.createObjectURL(file));
        img.style.width = '300px';
        imgDivElement.appendChild(img);
      } else {
        imgDivElement.classList.toggle('d-none', true);
      }
    });
  });

  // ラジオボタンでチェックされた項目のみ要素を開く
  const chekcedOpenContents = document.querySelectorAll('[data-role="chekced-open-contents"]');
  if(chekcedOpenContents.length) {
    chekcedOpenContents.forEach(checkList => {
      const inputs = checkList.querySelectorAll('.check-list-item input[type="radio"], .check-list-item input[type="checkbox"]');

      //ページ読み込み時に checked の .contents を開く
      inputs.forEach(input => {
        if (input.checked) {
          const content = input.closest('.check-list-item').querySelector('.check-list-item__contents');
          if (content) {
            slideDown(content, 300);
          }
        }
      });

      // ラジオボタンやチェックボックスの変更時の処理
      inputs.forEach(input => {
        input.addEventListener('change', function(){
          const newContent = this.closest('.check-list-item').querySelector('.check-list-item__contents');
          if (this.type === "radio") {
            // ラジオボタン: 他の .contents を閉じる
            const allContents = checkList.querySelectorAll('.check-list-item__contents');
            allContents.forEach(content => {
              if (content !== newContent && content) {
                slideUp(content, 300);
              }
            });
            // 新しい .contents を開く
            if (newContent) {
              slideDown(newContent, 300);
            }
          } else if (this.type === "checkbox") {
            // チェックボックス: チェックの有無で開閉
            if (newContent) {
              if (this.checked) {
                slideDown(newContent, 300);
              } else {
                slideUp(newContent, 300);
              }
            }
          }
        });
      });
    });
  }
});
